export const classificationLabels = {
  gender: 'Giới tính',
  function: 'Function',
  collaborator_type: 'Loại hình',
  working_time: 'Thời gian làm việc',
  work_location: 'Location',
  duration: 'Duration',
  counted_in_hc: 'Counted in HC',
  payment_type: 'Lương',
  has_office_pass: 'Thẻ ra vào/gửi xe',
  has_it_asset: 'Tài sản IT',
  has_seat: 'Chỗ ngồi',
  bpo_hris_profile_id: 'BPO HRIS Profile ID',
  hris_profile: 'HRIS Profile'
}
export const classificationFields = Object.keys(classificationLabels)
export const booleanFields = ['counted_in_hc', 'has_office_pass', 'has_it_asset', 'has_seat']
